var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "copy_svg__dl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.35,
    y: 112.83,
    width: 194.79,
    height: 250.82,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.35,
    y: 118.83,
    width: 182.79,
    height: 238.82,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "copy_svg__dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.86,314.14h51.72v-24h-27.72V84.35h149.77v27h-109.77c-6.62,0-12,5.38-12,12v229.8c0,6.62,5.38,12,12,12h173.77c6.62,0,12-5.38,12-12V123.35c0-6.62-5.38-12-12-12h-40v-51H87.86v253.8Zm76,27v-205.8h149.77v205.8h-149.77Z",
    style: {
      fill: "#f7f7f7"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.47e208fa3cd75e52a19f3ea46dc5e5fc.svg";
export { ForwardRef as ReactComponent };